import React from 'react';
import { Modal, Spinner } from 'hyperdb-utils';
import PropertyForm from './PropertyForm';

export default class PropertiesTab extends React.Component {
  constructor(props) {
    super(props);
    this.handleChangeProperty = this.handleChangeProperty.bind(this);
    this.handleSaveProperty = this.handleSaveProperty.bind(this);
    this.handleDeleteProperty = this.handleDeleteProperty.bind(this);
  }
  componentDidMount() {
    this.fetchProperties();
  }
  componentWillReceiveProps(nextProps) {
    const propertyProps = this.props.api.getState('property');
    if (propertyProps.submitSuccessful) {
      this.props.api.property.setData({ submitSuccessful: false });
      this.handleToggleModalForm(false);
      this.fetchProperties();
    }
    if (propertyProps.deleteSuccessful) {
      this.props.api.property.setData({ deleteSuccessful: false });
      this.handleToggleModalDelete(-1);
      this.fetchProperties();
    }
  }
  render() {
    const properties = this.props.api.getState('property').channel_properties || [];
    const processingProperty = this.props.api.getState('property').loading;
    return (
      <fieldset>
        <div className="box-header">
          <button type="button" className="btn btn-xs btn-primary" onClick={ this.handleToggleModalForm.bind(this, true, -1) }>Add</button>
        </div>
        <div className="table-responsive no-padding">
          { this.props.loading ? <div className="box box-body"><Spinner show={ true } /></div> : null }
          <table className="table table-hover table-striped table-bordered table-responsive">
            <thead>
              <tr>
                <th>name</th>
                <th>remote_id</th>
                <th>nb units</th>
                <th>active</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {
                properties.map((property, i) => {
                  return (
                    <tr key={ i }>
                      <td>{ property.name }</td>
                      <td>{ property.remote_id }</td>
                      <td>{ property.multi_unit === 1 ? property.nb_units : (property.units || []).length }</td>
                      <td>{ property.active ? <i className="fas fa-check" /> : null }</td>
                      <td>
                        <button type="button" className="btn btn-info btn-sm" onClick={ this.handleToggleModalForm.bind(this, true, i) }>Edit</button>
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
        {
          this.props.showModalFormProperty
            ? <Modal title={ !this.props.editedProperty.id ? 'Add property' : 'Edit property' } onClose={ this.handleToggleModalForm.bind(this, false) } onAccept={ this.handleSaveProperty } loading={ processingProperty }>
                <PropertyForm
                  { ...this.props }
                  property={ this.props.editedProperty }
                  onChange={ this.handleChangeProperty } />
              </Modal>
            : null
        }
        {/*
          this.props.showModalDeleteProperty
            ? <Modal title="Remove property from channel" onClose={ this.handleToggleModalDelete.bind(this, -1) } onAccept={ this.handleDeleteProperty } loading={ processingProperty }>
                Remove this property from channel ?
              </Modal>
            : null
        */}
      </fieldset>
    );
  }

  fetchProperties() {
    this.props.api.property.getObjects({
      propName: 'channel_properties',
      queryOptions: [['name', 'source_channel_id', 'remote_id', 'units', 'active', 'multi_unit', 'nb_units'], { where: { source_channel_id: this.props.objectData.id }, order: { name: 'asc' } }],
    });
  }

  handleToggleModalForm(bool, indexEditedProperty = -1) {
    const properties = this.props.api.getState('property').channel_properties || [];
    const editedProperty = bool && indexEditedProperty !== -1
      ? { ...properties[indexEditedProperty] }
      : {
        source_channel_id: { $type: 'reference', value: ['channels', this.props.channelId] },
        daily_rental: true,
        units: [{ active: true, number: 1}],
      };
    this.props.api.channel.setData({ showModalFormProperty: bool, indexEditedProperty, editedProperty });
  }
  handleChangeProperty(attributes) {
    this.props.api.channel.setData({ editedProperty: attributes });
  }
  handleSaveProperty() {
    const editedProperty = this.props.editedProperty;
    if (!editedProperty.id) {
      this.props.api.property.submitCreateForm(editedProperty);
    } else {
      this.props.api.property.submitEditForm({ id: editedProperty.id, objectData: editedProperty });
    }
  }

  handleToggleModalDelete(indexDeleteProperty = -1) {
    const showModalDeleteProperty = indexDeleteProperty !== -1;
    this.props.api.channel.setData({ showModalDeleteProperty, indexDeleteProperty });
  }
  handleDeleteProperty() {
    this.props.api.property.deleteObject(this.props.editedProperty);
  }
}

PropertyForm.propTypes = {
  api: React.PropTypes.object,
  channelId: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/channel/components/PropertiesTab.jsx